import { useMemo } from 'react';
import { useParams } from 'next/navigation';
import { getSdk } from 'sdk';

const useSdk = () => {
  const { locale } = useParams();
  const sdk = useMemo(() => getSdk(locale), [locale]);
  return sdk;
};

export default useSdk;
